import { Link } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import {
	useConfiguration,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { useDataBoxesContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';

export const DataBoxAddCreditModal = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const { creditModalDataBoxId, closeCreditModal } = useDataBoxesContext();
	const { datovaSchrankaDobitiKredituUrl } = useConfiguration();

	return (
		<Dialog
			isOpen={!!creditModalDataBoxId}
			onClose={closeCreditModal}
			title={<h3>{tn('kredit.presmerovani')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						nativeType="button"
						type="outlined"
						size="m"
						onClick={closeCreditModal}
						aria-label={tn('kredit.wcag.zrusit')}>
						{tn('kredit.zrusit')}
					</Button>
					<Button
						color="primary"
						type="solid"
						size="m"
						aria-label={tn('kredit.wcag.prejit')}
						iconEnd={
							<GovIcon
								name="box-arrow-up-right"
								type="components"
							/>
						}
						asChild>
						<Link
							to={datovaSchrankaDobitiKredituUrl.replace(
								'{{DS_ID}}',
								creditModalDataBoxId as string
							)}
							target="_blank">
							{tn('kredit.prejit')}
						</Link>
					</Button>
				</>
			}>
			<p>{tn('kredit.dobijete')}</p>
		</Dialog>
	);
};
